import HttpRequest from "@/plugins/axios";

class GenStudentIDProvider extends HttpRequest {
    constructor() {
        super(process.env.VUE_APP_API_URL);
    }

    async genStudentID(info) {
        const { data } = await this.post("/", {
            function: "gen-student-id",
            LEVEL: info.LEVEL,
            ADMIT_YEAR: info.YEAR,
            ADMIT_SEMESTER: info.SEMESTER,
            MODE: info.MODE,
            FORMAT: info.FORMAT,
        });
        return data;
    }
}

export default GenStudentIDProvider;